import { setThemeStore } from "@nurion/theme/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { loadConfig } from "~/config";
import { getThemeStore } from "~/lib/platform";
import { initSdkTelemetry } from "~/lib/telemetry";

import "~/styles/main.css";

import { App } from "~/App";

async function boot() {
  setThemeStore(getThemeStore());

  const config = await loadConfig();

  initSdkTelemetry({ dsn: config.sentryDsn || undefined });

  const container = document.getElementById("root");
  if (!container) {
    throw new Error("Root container #root not found in index.html");
  }

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
